var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "nutstore-robot" }, [
      _c(
        "a",
        {
          attrs: {
            target: "_blank",
            href: "https://www.jianguoyun.com/s/helpdesk"
          }
        },
        [_c("img", { attrs: { src: require("./float-help.svg"), alt: "" } })]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }